import { PAGE_TYPE } from "@faire/retailer-visitor-shared/consts/PAGE_TYPE";
import { ProductTileSurface } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/ProductTileSurface";

export const PRODUCT_TILE_SURFACE_MAP = {
  [ProductTileSurface.BRAND_PAGE]: PAGE_TYPE.BRAND,
  [ProductTileSurface.SEARCH_PAGE]: PAGE_TYPE.DISCOVER,
  [ProductTileSurface.SDUI]: PAGE_TYPE.BRAND,
  [ProductTileSurface.CART_PAGE]: PAGE_TYPE.CART,
};
